/**
 * InfinitSales - Contact Feedback Service
 * Per-contact prompt instructions ("feedbacks") that override agent training
 * for a specific conversation. Same payload regardless of channel.
 */
import api from './api';
import { isOpaqueKey } from '../../utils/channels';

// Chave do contato para a URL. Telefone vira so digitos; chave OPACA de
// Instagram/Messenger ('instagram:{igsid}' / 'messenger:{psid}') viaja
// intacta e codificada: apagar o prefixo aqui gravava tags, comentarios e
// campos numa chave indistinguivel de telefone (arquitetura empresarial,
// fase 1, mapa G). A canonizacao e sempre do servidor.
const sanitizePhone = (phone) => {
  if (!phone) return '';
  const raw = String(phone).trim();
  // O mapa de canais conhece os prefixos opacos (instagram:, messenger:,
  // widget:); um regex escrito a mao deixou o widget virar digitos (23/09).
  if (isOpaqueKey(raw)) return encodeURIComponent(raw);
  return raw.replace(/\D/g, '');
};

const contactFeedbackService = {
  /**
   * List all feedbacks for a contact (chronological order).
   * @param {string} phone - Contact phone (will be normalized to digits-only)
   */
  async listFeedbacks(phone) {
    const cleanPhone = sanitizePhone(phone);
    const res = await api.get(`/api/users/me/contacts/${cleanPhone}/feedbacks`);
    return res.data?.data || [];
  },

  /**
   * Append a new feedback to a contact.
   * @param {string} phone
   * @param {string} text
   */
  async addFeedback(phone, text) {
    const cleanPhone = sanitizePhone(phone);
    const res = await api.post(
      `/api/users/me/contacts/${cleanPhone}/feedbacks`,
      { text }
    );
    return res.data?.data;
  },

  /**
   * Remove a feedback by id.
   * @param {string} phone
   * @param {string} feedbackId
   */
  async removeFeedback(phone, feedbackId) {
    const cleanPhone = sanitizePhone(phone);
    const res = await api.delete(
      `/api/users/me/contacts/${cleanPhone}/feedbacks/${feedbackId}`
    );
    return res.data?.data;
  },
};

export default contactFeedbackService;
